import fontawesome  from '@fortawesome/fontawesome';
import solid from '@fortawesome/fontawesome-pro-solid';
import regular from '@fortawesome/fontawesome-pro-regular';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap/TweenMax';
import TimelineMax from 'gsap/TimelineMax';
import './_animation.gsap';

fontawesome.library.add(solid);
fontawesome.library.add(regular);
fontawesome.library.add(light);
fontawesome.library.add(brands);

var animations = {};
function animateValue(id, start, end, duration, draw) {
  var currentTime = (new Date()).getTime();
  if (animations[id] === undefined) {
    animations[id] = { startTime: currentTime };
  }
  var timeDifference = currentTime - animations[id].startTime;
  var range = start + ((end - start) * (timeDifference / duration));
  if (range > end) {
    range = end;
  }
  var obj = document.querySelector(id);
  var timer = window.requestAnimationFrame(function() {
      if (draw) {
        obj.innerHTML = draw(Math.round(range));
      } else {
        obj.innerHTML = Math.round(range);
      }
      if (range < end) {
        animateValue(id, start, end, duration, draw);
      } else {
        delete animations[id];
      }
  });
}

function numberWithCommas(x) {
  return x.toString().split('').reverse().join('').replace(/([0-9]{3})/g, '$1.').split('').reverse().join('').replace(/^\./, '');
}

function toHHMM (t) {
  var sec_num = parseInt(t, 10); // don't forget the second param
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return hours+':'+minutes;
}

// init controller
var controller = new ScrollMagic.Controller();

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger1', offset: -window.innerHeight / 4})
.on('enter', function () {
  animateValue('.count1', 0, 900, 1000);
  animateValue('.count2', 0, 122, 1000);
  animateValue('.count3', 0, 90, 1000, function(num) {
    return (num/10).toFixed(1).replace('.', ',');
  });
}, 0)
.reverse(true)
.addTo(controller);

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger2', offset: -window.innerHeight / 4})
    .on('enter', function (event) {
      animateValue('.count4', 0, 6500000, 2000, function(x) {
        return numberWithCommas(x);
      });
      animateValue('.count5', 0, 126500, 2000, function(x) {
        return numberWithCommas(x);
      });
      animateValue('.count6', 0, 6221000, 2000, function(x) {
        return numberWithCommas(x);
      });
    }, 0)
    .setClassToggle('.item img', 'flipX')
    .reverse(true)
    .addTo(controller);

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger3'})
    .on('enter', function () {
      anim.goToAndPlay(1, true);
      animateValue('.count7', 0, 33, 1500);
      animateValue('.count8', 0, 35600, 1500, function(x) {
        return numberWithCommas(x);
      });
    }, 0)
    .reverse(true)
    .addTo(controller);


// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger4', offset: -window.innerHeight / 4})
    .on('enter', function () {
      animateValue('.count9', 0, 23000, 1500, function(x) {
        return numberWithCommas(x);
      });
    }, 0)
    .setClassToggle('.phone', 'phone-reveal')
    .reverse(true)
    .addTo(controller);

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger5', offset: -window.innerHeight / 4})
    .on('enter', function () {
      animateValue('.count10', 0, 203, 1000);
    }, 0)
    .setClassToggle('.client-wrapper', 'flip-card')
    .reverse(true)
    .addTo(controller);

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger6', offset: -window.innerHeight / 4})
    .on('enter', function () {
      animateValue('.count11', 0, 3200, 2000, function(x) {
        return numberWithCommas(x);
      });
      animateValue('.count12', 0, 62000, 2000, function(x) {
        return numberWithCommas(x);
      });
    }, 0)
    .setClassToggle('.off', 'on')
    .reverse(true)
    .addTo(controller);

var scene = new ScrollMagic.Scene({triggerElement: '#trigger6', offset: -window.innerHeight / 4})
    .setClassToggle('.book-wrapper', 'in')
    .reverse(true)
    .addTo(controller);

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger7', offset: -window.innerHeight / 4})
  .on('enter', function () {
    animateValue('.count13', 0, 36900, 1000, function (t) {
      return toHHMM(t);
    });
    animateValue('.count14', 0, 7, 1000);
  }, 0)
  .setClassToggle('.clock-wrapper', 'run')
  .reverse(true)
  .addTo(controller);

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger8', offset: -window.innerHeight / 4})
    .on('enter', function () {
      animateValue('.count15', 0, 20, 1000);
    }, 0)
    .setClassToggle('.job-list', 'tick')
    .reverse(true)
    .addTo(controller);

// build scene
var scene = new ScrollMagic.Scene({triggerElement: '#trigger9', offset: -window.innerHeight / 4})
.on('enter', function () {
  animateValue('.count16', 0, 7, 1000);
}, 0)
.setClassToggle('.scrum-wrapper', 'scrum-reveal')
.reverse(true)
.addTo(controller);

new ScrollMagic.Scene({triggerElement: '.fashion', offset: -window.innerHeight / 4})
    .setClassToggle('.fashion-wrapper', 'content-reveal')
    .reverse(true)
    .addTo(controller);

new ScrollMagic.Scene({triggerElement: '#classTrigger', offset: -window.innerHeight / 4})
    .setClassToggle('#classTrigger', 'header-reveal')
    .reverse(true)
    .addTo(controller);

new ScrollMagic.Scene({triggerElement: '#videoTrigger', offset: -window.innerHeight / 4})
    .setClassToggle('#videoTrigger', 'content-reveal')
    .reverse(true)
    .addTo(controller);

new ScrollMagic.Scene({triggerElement: '#videoTriggerAlt', offset: -window.innerHeight / 4})
    .setClassToggle('#videoTriggerAlt', 'content-reveal')
    .reverse(true)
    .addTo(controller);

function scrollIt(destination, duration = 200, easing = 'linear', callback) {

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    }
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}

document.querySelector('.back-to-top').addEventListener('click', (e) => {
  e.preventDefault();
  scrollIt(
    document.querySelector('.navbar'),
    1000,
    'easeOutQuad'
  );
});
